// load-more.js (cursor-aware + pagination fallback)

let isLoading = false;

document.addEventListener('DOMContentLoaded', () => {
  console.log('[∞] DOMContentLoaded – initializing infinite scroll');
  const spinner = document.querySelector('.js-infinite-scroll');
  if (!spinner) {
    console.log('[∞] No spinner element found – infinite scroll disabled');
    return;
  }

  const wrapper = spinner.closest('.collection-wrapper');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('[∞] Spinner in view – triggering loadItems');
        loadItems(spinner, wrapper);
      }
    });
  }, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(spinner);
});

function loadItems(spinner, wrapper) {
  if (isLoading) {
    console.log('[∞] Already loading – skipping');
    return;
  }
  isLoading = true;
  spinner.classList.add('loading');

  const nextInput     = wrapper.querySelector('input[data-next-url]');
  const currentInput  = wrapper.querySelector('input[data-current-page]');
  const totalPagesInp = wrapper.querySelector('input[data-total-pages]');

  console.log('[∞] Fetching URL:', nextInput.value);

  fetch(nextInput.value)
    .then(res => res.text())
    .then(htmlString => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // 1) Append new products
      const newItemsHtml = doc.querySelector('.load-more-grid').innerHTML;
      wrapper.querySelector('.load-more-grid').insertAdjacentHTML('beforeend', newItemsHtml);

      // 2) Update hidden inputs via infinite-scroll snippet or pagination fallback
      let newNext, newCurrent, newTotal;
      const newData = doc.querySelector('.infinite-scroll__data');

      if (newData) {
        newNext    = newData.querySelector('input[data-next-url]').value;
        newCurrent = newData.querySelector('input[data-current-page]').value;
        newTotal   = newData.querySelector('input[data-total-pages]').value;
      } else {
        // Fallback: find the default pagination block
        const pagination = doc.querySelector('.pagination');
        if (pagination) {
          const nextAnchor = pagination.querySelector('li.pagination__item--next a')
                           || pagination.querySelector('a[rel="next"]')
                           || pagination.querySelector('a[href*="page="]');
          if (nextAnchor) newNext = nextAnchor.getAttribute('href');
          newCurrent = (parseInt(currentInput.value, 10) + 1).toString();
          newTotal   = totalPagesInp.value;
        }
      }

      if (newNext) {
        nextInput.value = newNext;
        nextInput.dataset.nextUrl = newNext;
      }
      if (newCurrent) {
        currentInput.value = newCurrent;
        currentInput.dataset.currentPage = newCurrent;
      }
      if (newTotal) {
        totalPagesInp.value = newTotal;
      }

      if (typeof colorSwatches === 'function') colorSwatches();
    })
    .catch(err => console.error('[∞] Error loading items', err))
    .finally(() => {
      spinner.classList.remove('loading');
      isLoading = false;
      const currentPage = parseInt(wrapper.querySelector('input[data-current-page]').value, 10);
      const totalPages  = parseInt(wrapper.querySelector('input[data-total-pages]').value, 10);
      if (currentPage >= totalPages) {
        console.log('[∞] Last page reached – removing spinner');
        spinner.remove();
      }
    });
}
